import axios from "axios";
import Cookies from "js-cookie";
import { setCachedSubscriptionStatus } from "../utils/subscriptionStatus";

export const googleLogin = async (code, hostname) => {

  // 1. Exchange code for tokens and user info
  const res = await axios.post(
    `${process.env.REACT_APP_BASE_URL}api/v1/accounts/google/auth/`,
    { code }
  );

  const { access_token, refresh_token, user } = res.data;

  if (!access_token || !refresh_token || !user) {
    throw new Error("Incomplete login response: access_token, refresh_token, or user missing.");
  }



  localStorage.setItem("access_token", access_token);
  localStorage.setItem("refresh_token", refresh_token);



  document.cookie = `access_token=${access_token}; path=/;`;
  document.cookie = `refresh_token=${refresh_token}; path=/;`;

  // 3. Save user info
  localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("email", user.email);
  localStorage.setItem("username", user.username);

  // 4. Optionally refetch user to confirm token works (if needed)
  // If you already get full user object from /google/auth/, you can skip this.
  // But if you want to double-check:
  const userCheck = await axios.get(
    `${process.env.REACT_APP_BASE_URL}api/v1/accounts/user/`,
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    }
  );

  // Fetch workspaces and set the owner org in cookie (mirrors OTP sign-in flow).
  try {
    const orgRes = await axios.get(
      `${process.env.REACT_APP_BASE_URL}api/v1/org/`,
      { headers: { Authorization: `Bearer ${access_token}` } }
    );

    if (orgRes.status === 200 && Array.isArray(orgRes.data)) {
      const orgs = orgRes.data;
      localStorage.setItem("cachedWorkspaces", JSON.stringify(orgs));

      const ownerOrg = orgs.find(org => org.permission === "owner");
      const defaultOrg = ownerOrg || (orgs.length > 0 ? orgs[0] : null);

      if (defaultOrg) {
        localStorage.setItem("activeWorkspace", JSON.stringify(defaultOrg));
        localStorage.setItem("activeWorkspaceId", defaultOrg.id.toString());
      }

      if (ownerOrg) {
        Cookies.set("selected_org_id", ownerOrg.id.toString(), { expires: 365 });
      }
    }
  } catch (orgError) {
    console.error("Error fetching workspaces during Google sign-in:", orgError);
  }

  // Cache subscription status once at login.
  try {
    const subRes = await axios.get(
      `${process.env.REACT_APP_BASE_URL}api/v1/accounts/get-subscription-status/`,
      { headers: { Authorization: `Bearer ${access_token}` } }
    );
    setCachedSubscriptionStatus(subRes.data);
  } catch (subErr) {
    console.error("Error fetching subscription status during Google sign-in:", subErr);
  }

  userCheck.auth = res.data;
  return userCheck;
};
